/// <reference path="../../../../../typings/index.d.ts" />
///<reference path="../../../components/baseClasses/dataMaintenanceSectionBase.ts"/>
///<reference path="ym-section-base.ts"/>


module Meevo.Plugins.YieldManagementProgram {

    import MemberStatusEnum = Meevo.Model.MemberStatusEnum;
    import ISelectItem = Meevo.Model.ISelectItem;

    export class YieldManagerStrategyClientSection extends YmSectionBase {
        public membershipDropDownOptions: ISelectItem<MemberStatusEnum>[];

        public get showMembershipMover(): boolean {
            return this.model.memberStatus === MemberStatusEnum.Member && this.isCreatedInCurrentLocation;
        }

        public get showClientTypeMover(): boolean {
            return this.model.filterByClientType && this.isCreatedInCurrentLocation;
        }

        constructor(
            sectionId: number,
            displayNameContentKey: string,
            template: string,
            isPrimarySection: boolean,
            handlesOwnCrud: boolean,
            baseEndpoint: string,
            sectionEndpoint: string,
            loggingService: Components.Logging.ILoggingService,
            dataService: Components.BaseClasses.IDataService,
            identityService: Components.Common.IIdentityService,
            noun: Model.NounEnum = null,
            appSettings: Meevo.Components.Common.IAppSettings,
            sectionSecurityKey?: string) {
            super(sectionId, displayNameContentKey, template, isPrimarySection, handlesOwnCrud, baseEndpoint, sectionEndpoint, loggingService, dataService, identityService, noun, appSettings, sectionSecurityKey);

            this.membershipDropDownOptions = [
                {label: 'LABEL_EVERYONE', value: MemberStatusEnum.All},
                {label: 'LABEL_ONLY_NON_MEMBER', value: MemberStatusEnum.NonMember},
                {label: 'LABEL_ONLY_MEMBER', value: MemberStatusEnum.AllMembers},
                {label: 'LABEL_ONLY_SPECIFIC_MEMBERSHIPS', value: MemberStatusEnum.Member},
            ];
        }

        canEdit(): boolean {
            return this.isCreatedInCurrentLocation;
        }
    }
}
